import { API_MASTER_DATA } from '../../service/index'
import axios from 'axios'
import router from '../../router'

export default {
  state: {
    BranchId: null,
    BranchDetail: null,
    restaurantId: null,
    roundingType: 0
    // PreOrderDetail: null
  },
  mutations: {
    setBranchId (state, BranchId) {
			state.BranchId = BranchId
    },
    setResId (state, restaurantId) {
      state.restaurantId = restaurantId
    },
    setBranchDetail (state, BranchDetail) {
      state.BranchDetail = BranchDetail
    },
    setRoundingType (state, BranchDetail) {
      state.roundingType = BranchDetail.roundingType || 0
    }
    // setPreOrderDetail (state, list) {
    //   state.PreOrderDetail = list
    // }
  },
  actions: {
    async getBranchDetail ({commit}, payload) {
        var branch = await axios({
          method: 'GET',
          url: API_MASTER_DATA + 'restaurants/' + payload.restaurant_uuid + '/branches/' + payload.branch_uuid,
          responseType: 'json'
        }).then((response) => {
          return (response.data.meta.status === 200) ? response.data.data : []
        }).catch(() => {
          return []
        })

        branch = Object.assign(branch, { restaurant_uuid: '2571bfde-97da-47d2-b6bb-c01b2ec42dd7' })

        commit('setBranchDetail', branch)
        commit('setRoundingType', branch)
        return branch
    },
    setKeyToLacalStorage ({commit}, payload) {
      localStorage.setItem('restaurant', JSON.stringify({
        uuid: payload.restaurant_uuid,
        alias: payload.restaurantAlias
      }))
      localStorage.setItem('branch', JSON.stringify({
        uuid: payload.branch_uuid,
        alias: payload.branchAlias
      }))
			commit('setResId', payload.restaurant_uuid)
			commit('setBranchId', payload.branch_uuid)
    }
  },
  getters: {
		BranchId (state) {
			return state.BranchId
    },
    restaurantId (state) {
      return state.restaurantId
    },
    BranchDetail (state) {
      return state.BranchDetail
    },
    roundingType (state) {
      return state.roundingType
    }
    // PreOrderDetail (state) {
    //   return state.PreOrderDetail
    // }
  }
}



// WEBPACK FOOTER //
// ./src/store/branch/index.js